// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"93321f77a8e33f968dd2","655":"120f0520096f727e1279"}[chunkId] + ".js";
};